/**
 * Barrel export for Product Cards constants.
 */

export {
  PRODUCT_FIELDS,
  DEFAULT_FIELD_ORDER,
  DEFAULT_ENABLED_FIELD_IDS,
  IMAGE_FIELD_ID,
  CTA_FIELD_ID,
  DESC_FIELD_ID,
  BLOCKLESS_FIELD_IDS,
  STRETCH_BLOCK_FIELD_IDS,
  rendersBlock,
  isStretchBlock,
  DEFAULT_IMAGE_FIT,
  IMAGE_FITS,
  isImageFit,
  isKnownFieldId,
  getFieldDefinition,
  getDefaultFieldConfiguration,
} from './fields.config';

export { PROPERTY_SECTIONS, PROPERTY_SECTION_ORDER } from './propertySections.config';

export {
  FIELD_SELECTORS,
  FIELD_PANEL_NAMES,
  getFieldSelector,
  getFieldClassName,
  getFieldPanelName,
  PREVIEW_SCOPE_CLASS,
  MAX_CUSTOM_CSS_LENGTH,
  MAX_CUSTOM_CSS_DECLARATIONS,
} from './elements.config';

export {
  DESCRIPTION_STYLES,
  DEFAULT_DESCRIPTION_STYLE,
  isDescriptionStyle,
  CTA_WIDTH_PCT_RANGE,
  CTA_HEIGHT_PX_RANGE,
  MAX_CTA_LABEL_LENGTH,
  DEFAULT_CTA_CONFIGURATION,
  clampToRange,
} from './configuration.config';
export type { NumericRange } from './configuration.config';

export {
  REGIONS,
  getRegionName,
  PHOTO_ANCHORS,
  DEFAULT_PHOTO_ANCHOR,
  FLOATING_ANCHOR,
  SUGGESTED_REGION,
  DEFAULT_SUGGESTED_PLACEMENT,
  getSuggestedPlacement,
  isPhotoAnchor,
  isRegionId,
} from './regions.config';
export type { RegionDefinition, PhotoAnchorDefinition, SuggestedPlacement } from './regions.config';

export {
  APPLICATIONS,
  getApplication,
  getApplicationLabel,
  isApplicationRef,
} from './applications.config';
export type { ApplicationDefinition } from './applications.config';

export {
  CARD_BLOCK_DND_TYPE,
  RAIL_DND_TYPE,
  RAIL_DROPPABLE_ID,
  FLOATING_DROPPABLE_ID,
  INFO_GAP_PREFIX,
  INFO_ROW_PREFIX,
  PHOTO_PREFIX,
  photoAnchorDroppableId,
  infoGapDroppableId,
  infoRowDroppableId,
  blockDraggableId,
  railDraggableId,
  parseDraggableFieldId,
  regionForDroppable,
  parseLaneIndex,
} from './dnd.config';

export { formatUpdatedAt, EMPTY_DATE_PLACEHOLDER } from './date';

export { STRINGS } from './strings';

export { PREVIEW_PRODUCT, formatPrice } from './product.sample';
export type { PreviewProduct } from './product.sample';

/**
 * The module's own routes. `src/App.tsx` registers these two paths and
 * `MenuHelper.ts` points the nav entry at the first one; both are outside the
 * module folder, which is why the literal is duplicated there rather than
 * imported across the boundary.
 */
export const PRODUCT_CARDS_ROUTE = '/gms/product_cards';
export const cardEditorRoute = (cardId: string): string =>
  `${PRODUCT_CARDS_ROUTE}/${encodeURIComponent(cardId)}`;

/** Maximum lengths for user-typed text, enforced on write (threat model). */
export const MAX_CARD_NAME_LENGTH = 120;
export const MAX_DISPLAY_LABEL_LENGTH = 60;

/** Show-count options at the bottom of the listing (spec R23; 100 added 2026-08-19). */
export const SHOW_COUNT_OPTIONS: number[] = [10, 25, 50, 100];
export const DEFAULT_SHOW_COUNT = 10;

/**
 * Quiet time after the last keystroke before the search hits the server —
 * every listing interaction is an API call, so as-you-type must coalesce.
 * 500 rather than 300 (operator, 2026-08-19): deliberate typing pauses often
 * exceed 300ms, which made every keystroke look like "done typing" and fire.
 */
export const LISTING_SEARCH_DEBOUNCE_MS = 500;

/** Debounce before an edit is written through the repository (ADR-002). */
export const AUTOSAVE_DEBOUNCE_MS = 500;
